import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { DataGrid } from 'devextreme-react';
import ReactDOM from "react-dom/client";
import { IAvailableResults } from 'interfaces/HistoricalResults/IAvailableResults';
import './AvailableResultsGrid.scss';

const AvailableResultsGrid = ({ results }) => {
  const availableResults = useMemo<IAvailableResults[]>(() => results, [results]);
  const navigate = useNavigate();
  return (
    <DataGrid
      className="availableResults"
      dataSource={availableResults}
      rowAlternationEnabled={true}
      showBorders={false}
      wordWrapEnabled={true}
      hoverStateEnabled={false}
      onRowDblClick={(e) =>
        navigate(`/online-results/${encodeURIComponent(e?.data?.RegTid)}/${encodeURIComponent(e?.data?.EnvirolabBranch)}`, {
          replace: true,
        })
      }
      paging={{enabled: true, pageSize: 10}}
      filterRow={{visible: true}}
      headerFilter={{visible: true}}
      columns={[
        {dataField:"URegRef", caption:"Lab Reference", dataType:"string"},
        {dataField:"Description", caption:"Description", dataType:"string" },
        {dataField:"RegDate", caption:"Date Received", format:'dd/MM/yyyy', sortOrder:"desc", dataType:"date" },
        {dataField:"Status", dataType:"string" },
        {
          dataField: "RegTid", // This column doesn't need a caption because it's a link column
          caption: "",
          cssClass: "linkCell",
          width: 100,
          alignment: "center",
          dataType: "string",
          cellTemplate: (container, options) => {
            const { RegTid, EnvirolabBranch } = options.data || {};
      
            // Ensure data exists
            if (!RegTid || !EnvirolabBranch) return;
      
            // Encode URL parameters safely
            const encodedRegTid = encodeURIComponent(RegTid);
            const encodedBranch = encodeURIComponent(EnvirolabBranch);
            const url = `/online-results/${encodedRegTid}/${encodedBranch}`;
            const linkElement = (
              <a href={url} className="view-link">
                <VisibilityIcon /> <span>View</span>
              </a>
            );
      
            // Ensure previous contents are cleared
            while (container.firstChild) {
              container.removeChild(container.firstChild);
            }
      
            // Create a React root and render the link inside the cell
            const root = ReactDOM.createRoot(container);
            root.render(linkElement);
          },
        },

      ]}
      />
  );
};

export default AvailableResultsGrid;
